var track = function track(_ref) {
  var category = _ref.category,
      action = _ref.action,
      label = _ref.label,
      value = _ref.value;

  if (!category || !action) {
    throw new Error('tracking category and action required');
  }

  if (typeof ga !== 'undefined') {
    // Track event
    ga('send', {
      hitType: 'event',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
      transport: 'beacon'
    });
  }

  if (typeof fbq !== 'undefined') {
    fbq('track', 'Lead', {
      content_category: category,
      content_name: action,
      label: label,
      value: value
    });
  }
};

export default track;